import { handleActions } from "redux-actions";

import { assetLeadSort, nextSortDir, updateById } from "utils";
import { filter } from "utils/assetLeads";

const assetLeadReducer = handleActions(
  {
    ASSET_LEADS_FILTER: ({ assetLeads }, { meta: { filters } }) => ({
      filteredAssetLeads: filter(assetLeads, filters),
    }),

    ASSET_LEADS_GET: {
      PENDING: () => ({
        assetLeads: [],
        filteredAssetLeads: [],
      }),
      FULFILLED: (_, { payload: { assetLeads } }) => ({
        assetLeads,
      }),
    },

    ASSET_LEADS_SORT: (
      { assetLeads, assetLeadsSortDir, assetLeadsSortKey, filteredAssetLeads },
      { payload: { key } }
    ) => {
      const sortDir = key === assetLeadsSortKey ? nextSortDir(assetLeadsSortDir) : "asc";

      return {
        assetLeadsSortDir: sortDir,
        assetLeadsSortKey: key,
        assetLeads: assetLeadSort(assetLeads, key, sortDir),
        filteredAssetLeads: assetLeadSort(filteredAssetLeads, key, sortDir),
      };
    },

    ASSET_LEAD_GET: {
      FULFILLED: ({ assetLeads }, { payload: { assetLead } }) => ({
        assetLeads: [...assetLeads.filter((lead) => lead.id !== assetLead.id), assetLead],
      }),
    },

    ASSET_LEAD_UPDATE: {
      FULFILLED: ({ assetLeads, filteredAssetLeads, posts }, { payload: { assetLead } }) => ({
        assetLeads: updateById(assetLeads, assetLead),
        filteredAssetLeads: updateById(filteredAssetLeads, assetLead),
        posts: [assetLead.lastItem, ...posts],
      }),
    },

    ASSET_LEAD_CREATE: {
      FULFILLED: ({ assetLeads }, { payload: { assetLead } }) => ({
        assetLeads: [...assetLeads, assetLead],
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default assetLeadReducer;
